'use strict';

export default angular
  .module('maestro.directives.common.drop', [])

  .directive('drop', function drop() {
    return {
      link: function(scope, element) {
        element.dropdown({
          on: 'hover'
        });
      }
    };
  })

  .name;
